module.exports = __webpack_public_path__ + "static/media/img87_R.da611b32.jpg";